"use client";

import { Button } from "@/components/ui/button";
import { FC, useState } from "react";
import SupportModal from "@/components/entities/support-block/support-modal";
import { FeedbackResourceFormEnum, ServiceCenterPageResourceBlock } from "@/api/generated-api";
import { useTranslations } from "next-intl";
import S from "./index.module.scss";

interface ISupportBlock {
  info: ServiceCenterPageResourceBlock;
}

const SupportBlock: FC<ISupportBlock> = ({ info: { title, button, subtitle, description } }) => {
  const t = useTranslations();
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <div className={S.supportWrapper}>
        <div className={S.supportContent}>
          <h2 className={S.supportTitle}>{title}</h2>
          <h3 className={S.supportSubTitle}>{subtitle}</h3>
          <Button onClick={() => setShowModal(true)}>{button?.title}</Button>
        </div>
        <span className={S.supportDescription}>{description}</span>
      </div>
      {showModal && (
        <SupportModal
          form={FeedbackResourceFormEnum.ServiceCenter}
          title={t("form.contactForm")}
          onClose={() => setShowModal(false)}
        />
      )}
    </>
  );
};

export default SupportBlock;
